module.exports = __webpack_public_path__ + "media/images/emblems/Volken-blazon-94acfb85ba110b39607f4f0dd6a103db.svg";